import(/* webpackMode: "eager" */ "/app/app/reset.css");
import(/* webpackMode: "eager" */ "/app/app/global.css");
import(/* webpackMode: "eager" */ "/app/node_modules/flag-icons/css/flag-icons.min.css");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js")